import { gql } from '@apollo/client'

export const UPDATE_M2_CASE_MUTATION = gql`
  mutation updateM2Case($id: ID!, $attributes: M2CaseInput!, $shouldNotify: Boolean) {
    updateM2Case(id: $id, attributes: $attributes, shouldNotify: $shouldNotify) {
      id
    }
  }
`
